import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ProcFeePageUI from './ProcFeePageUI.js'

class ProcFeePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      response: null,
      accountFeeList: null,
      response: null
    }
  }

  render() {
    return (
      <ProcFeePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        response={this.state.response}
        accountFeeList={this.state.accountFeeList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProcessingFees(context)
  }

  getProcessingFees(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/processingFees`,
      cacheKey: CacheKeys.ProcessingFees(),
      callback: this.getProcessingFeesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProcessingFeesCallback = (response) => {
    this.setState({ errorList: response.errorList, response: response, accountFeeList: response.accountFeeList })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ProcessingFees())
    this.setState({
      accountFeeList: null,
      errorList: null,
    })
    this.getProcessingFees(context)
  }
}

export default ProcFeePageSF
